import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../mockData';

const MENU_Z_INDEX = 2000;
const OVERLAY_Z_INDEX = MENU_Z_INDEX - 1;

const HamburgerMenu = () => {
  const { language } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const navItems = content[language].nav.items;

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <>
      {/* Hamburger Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          position: 'fixed',
          top: '40px',
          left: '60px',
          zIndex: MENU_Z_INDEX,
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: '8px',
          display: 'flex',
          flexDirection: 'column',
          gap: '6px'
        }}
        aria-label="Menu"
      >
        <span
          style={{
            width: '24px',
            height: '1.5px',
            background: isOpen ? 'var(--charcoal)' : '#ffffff',
            transition: 'all 0.3s ease',
            transform: isOpen ? 'rotate(45deg) translateY(7.5px)' : 'none'
          }}
        />
        <span
          style={{
            width: '24px',
            height: '1.5px',
            background: isOpen ? 'var(--charcoal)' : '#ffffff',
            transition: 'all 0.3s ease',
            opacity: isOpen ? 0 : 1
          }}
        />
        <span
          style={{
            width: '24px',
            height: '1.5px',
            background: isOpen ? 'var(--charcoal)' : '#ffffff',
            transition: 'all 0.3s ease',
            transform: isOpen ? 'rotate(-45deg) translateY(-7.5px)' : 'none'
          }}
        />
      </button>

      {/* Menu Overlay */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(248, 246, 243, 0.98)',
          zIndex: OVERLAY_Z_INDEX,
          opacity: isOpen ? 1 : 0,
          pointerEvents: isOpen ? 'all' : 'none',
          transition: 'opacity 0.4s ease',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <nav>
          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              textAlign: 'center'
            }}
          >
            {navItems.map((item, index) => (
              <li
                key={item.id}
                style={{
                  marginBottom: '32px',
                  opacity: isOpen ? 1 : 0,
                  transform: isOpen ? 'translateY(0)' : 'translateY(20px)',
                  transition: `opacity 0.5s ease ${index * 0.1}s, transform 0.5s ease ${index * 0.1}s`
                }}
              >
                <button
                  onClick={() => scrollToSection(item.id)}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontFamily: 'Playfair Display, serif',
                    fontSize: 'clamp(1.75rem, 3vw, 2.5rem)',
                    color: 'var(--charcoal)',
                    cursor: 'pointer',
                    transition: 'color 0.3s ease',
                    padding: '8px 0',
                    fontWeight: 400
                  }}
                  onMouseEnter={(e) => e.target.style.color = 'var(--gold)'}
                  onMouseLeave={(e) => e.target.style.color = 'var(--charcoal)'}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </>
  );
};

export default HamburgerMenu;
